/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingPlanDefinitionListRequest {
    getFixupPrototypeFunction() { return BillingPlanDefinitionListRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingPlanDefinitionListRequest>): BillingPlanDefinitionListRequest {
        let obj = Object.assign(new BillingPlanDefinitionListRequest(), model);
        BillingPlanDefinitionListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingPlanDefinitionListRequest>): BillingPlanDefinitionListRequest {
        if (!model) return null;
        return BillingPlanDefinitionListRequest.newInstance(<BillingPlanDefinitionListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingPlanDefinitionListRequest) {
        if (!obj) return;

        models.BillingPlanDefinitionListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingPlanDefinitionListRequest): boolean {
        Object.setPrototypeOf(obj, BillingPlanDefinitionListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.BillingPlanDefinitionFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.BillingPlanDefinitionListSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.BillingPlanDefinitionListSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.BillingPlanDefinitionFilters;

}
